import './style.scss';

import Swiper from 'swiper/bundle';

import 'swiper/css/bundle';

// eslint-disable-next-line no-unused-vars
const photoSlider = new Swiper('.photo-slider', {
  slidesPerView: "auto",
  spaceBetween: 16,
  observer: true,
  observeParents: true,
  breakpoints: {
    768: {
      spaceBetween: 24,
    }
  },
});